import { PriceDirectionNullable } from "../../../../../../../../../../services/cloudchipr.api";

export const largesCostChangesWidgetSortingOrderLabels: Map<
  PriceDirectionNullable,
  string
> = new Map([
  ["increasing", "Increase"],
  ["decreasing", "Decrease"],
]);
